import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import LogoSti from "../logo_sti-alpha.png";
import { useNavigate } from "react-router-dom";

const HomePage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const isLoggedIn = localStorage.getItem("isLoggedIn");
    const expiryTimeCertificate = parseInt(localStorage.getItem("expiryTimeCertificate"), 10);

    if (!isLoggedIn) {
      if (!expiryTimeCertificate || Date.now() > expiryTimeCertificate) {
        // Hapus token dan waktu kedaluwarsa jika tidak valid
        localStorage.removeItem("isLoggedIn");
        localStorage.removeItem("expiryTimeCertificate");
        navigate("/"); // Redirect ke login
        return;
      }
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem("isLoggedIn");
    navigate("/");
  };

  const navRef = useRef(null);

  useEffect(() => {
    if (!navRef.current) {
      console.error("Element with ID 'mainNav' not found!");
      return;
    }

    let scrollPos = 0;
    const headerHeight = navRef.current.clientHeight;

    const handleScroll = () => {
      const currentTop = document.body.getBoundingClientRect().top * -1;
      if (currentTop < scrollPos) {
        if (currentTop > 0 && navRef.current.classList.contains("is-fixed")) {
          navRef.current.classList.add("is-visible");
        } else {
          navRef.current.classList.remove("is-visible", "is-fixed");
        }
      } else {
        navRef.current.classList.remove("is-visible");
        if (currentTop > headerHeight && !navRef.current.classList.contains("is-fixed")) {
          navRef.current.classList.add("is-fixed");
        }
      }
      scrollPos = currentTop;
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <nav ref={navRef} className="navbar navbar-expand-lg navbar-light" id="mainNav">
        <div className="container px-4 px-lg-5">
          <Link to={`/home`} className="navbar-brand text-uppercase">
            Certificate - STII
          </Link>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
            Menu
            <i className="fas fa-bars"></i>
          </button>
          <div className="collapse navbar-collapse" id="navbarResponsive">
            <ul className="navbar-nav ms-auto py-4 py-lg-0">
              <li className="nav-item">
                <Link to={`/home`} className="nav-link px-lg-3 py-3 py-lg-4">
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link to={`/certificate`} className="nav-link px-lg-3 py-3 py-lg-4" href="about.html">
                  Certificate
                </Link>
              </li>
              <li className="nav-item">
                <a className="nav-link px-lg-3 py-3 py-lg-4">About</a>
              </li>
              <li className="nav-item">
                <a className="nav-link px-lg-3 py-3 py-lg-4">Contact</a>
              </li>
              <li className="nav-item">
                <a className="nav-link px-lg-3  py-3 py-lg-4">
                  <button className="btn btn-sm btn-secondary rounded" onClick={handleLogout}>
                    Log Out
                  </button>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      <header className="masthead" style={{ backgroundImage: "url('/assets/img/lok-bg.jpg')", height: "100vh" }}>
        <div className="container position-relative px-4 px-lg-5">
          <div className="row gx-4 gx-lg-5 justify-content-center">
            <div className="col-md-10 col-lg-8 col-xl-7">
              <div className="site-heading">
                <h2>PT Sumatera Timber Indo Industry</h2>
                <img src={LogoSti} alt="Logo STI" />
                <br />
                <Link to={`/certificate`} className="btn btn-sm btn-primary mt-4 rounded text-uppercase">
                  See Certificate
                </Link>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* <div className="container px-4 px-lg-5">
        <div className="row gx-4 gx-lg-5 justify-content-center">
          <div className="col-md-10 col-lg-8 col-xl-7">
            <div className="post-preview">
              <a href="post.html">
                <h2 className="post-title">Man must explore, and this is exploration at its greatest</h2>
                <h3 className="post-subtitle">Problems look mighty small from 150 miles up</h3>
              </a>
              <p className="post-meta">
                Posted by
                <a href="#!">Start Bootstrap</a>
                on September 24, 2023
              </p>
            </div>

            <hr className="my-4" />

            <div className="post-preview">
              <a href="post.html">
                <h2 className="post-title">I believe every human has a finite number of heartbeats. I don't intend to waste any of mine.</h2>
              </a>
              <p className="post-meta">
                Posted by
                <a href="#!">Start Bootstrap</a>
                on September 18, 2023
              </p>
            </div>

            <hr className="my-4" />

            <div className="post-preview">
              <a href="post.html">
                <h2 className="post-title">Science has not yet mastered prophecy</h2>
                <h3 className="post-subtitle">We predict too much for the next year and yet far too little for the next ten.</h3>
              </a>
              <p className="post-meta">
                Posted by
                <a href="#!">Start Bootstrap</a>
                on August 24, 2023
              </p>
            </div>

            <hr className="my-4" />

            <div className="post-preview">
              <a href="post.html">
                <h2 className="post-title">Failure is not an option</h2>
                <h3 className="post-subtitle">Many say exploration is part of our destiny, but it’s actually our duty to future generations.</h3>
              </a>
              <p className="post-meta">
                Posted by
                <a href="#!">Start Bootstrap</a>
                on July 8, 2023
              </p>
            </div>

            <hr className="my-4" />

            <div className="d-flex justify-content-end mb-4">
              <a className="btn btn-primary text-uppercase" href="#!">
                Older Posts →
              </a>
            </div>
          </div>
        </div>
      </div> */}

      {/* <footer className="border-top">
        <div className="container px-4 px-lg-5">
          <div className="row gx-4 gx-lg-5 justify-content-center">
            <div className="col-md-10 col-lg-8 col-xl-7">
              <ul className="list-inline text-center">
                <li className="list-inline-item">
                  <a href="#!">
                    <span className="fa-stack fa-lg">
                      <i className="fas fa-circle fa-stack-2x"></i>
                      <i className="fab fa-twitter fa-stack-1x fa-inverse"></i>
                    </span>
                  </a>
                </li>
                <li className="list-inline-item">
                  <a href="#!">
                    <span className="fa-stack fa-lg">
                      <i className="fas fa-circle fa-stack-2x"></i>
                      <i className="fab fa-facebook-f fa-stack-1x fa-inverse"></i>
                    </span>
                  </a>
                </li>
                <li className="list-inline-item">
                  <a href="#!">
                    <span className="fa-stack fa-lg">
                      <i className="fas fa-circle fa-stack-2x"></i>
                      <i className="fab fa-github fa-stack-1x fa-inverse"></i>
                    </span>
                  </a>
                </li>
              </ul>
              <div className="small text-center text-muted fst-italic">Copyright &copy; Your Website 2023</div>
            </div>
          </div>
        </div>
      </footer> */}
    </>
  );
};

export default HomePage;
